import React from "react";
import { number, array, object, func, string } from "prop-types";
import get from "lodash/get";

import { getAuthorStories } from "../../helper/api";

class LoadMoreStoriesManager extends React.Component {
  state = {
    pageNumber: 1,
    moreStories: [],
    loading: false,
  };

  getStories() {
    return this.props.stories.concat(this.state.moreStories);
  }

  removeDuplicateStories(existingStories, newStories, keyFn = (story) => story.id) {
    const existingStoryIds = existingStories.map(keyFn);
    return newStories.filter((story) => !existingStoryIds.includes(keyFn(story)));
  }

  loadMore(e) {
    e.preventDefault();

    const { pageNumber, moreStories } = this.state;

    this.setState({ pageNumber: pageNumber + 1, loading: true }, () => {
      this.props.loadStories(pageNumber).then((stories) => {
        this.setState({
          moreStories: moreStories.concat(this.removeDuplicateStories(this.getStories(), stories)),
          loading: false,
        });
      });
    });
  }

  render() {
    return this.props.template(
      Object.assign({}, this.props, {
        stories: this.getStories(),
        onLoadMore: (e) => this.loadMore(e),
        loading: this.state.loading,
      })
    );
  }
}

const LoadMoreAuthorStories = (props) => {
  const loadMoreStories = (pageNumber) => {
    const stories = get(props, ["data", "stories"], []);
    const params = Object.assign({}, props.params, {
      offset: props.numStoriesToLoad * (pageNumber - 1) + stories.length,
      limit: props.numStoriesToLoad || 10,
    });

    return getAuthorStories(props.authorID, params).then((storyList) => {
      return storyList;
    });
  };

  return React.createElement(
    LoadMoreStoriesManager,
    Object.assign({}, props.data, {
      template: props.template,
      loadStories: (pageNumber) => loadMoreStories(pageNumber),
      languageDirection: props.languageDirection,
      numStoriesToLoad: props.numStoriesToLoad || 10,
    })
  );
};

LoadMoreStoriesManager.propTypes = {
  stories: array,
  loadStories: func,
  numStoriesToLoad: number,
  template: func,
};

LoadMoreAuthorStories.propTypes = {
  authorID: number,
  data: object,
  stories: array,
  params: object,
  numStoriesToLoad: number,
  template: func,
  setLoading: func,
  languageDirection: string,
};

export default LoadMoreAuthorStories;
